import { render, staticRenderFns } from "./BothStore.vue?vue&type=template&id=5f1875be&"
import script from "./BothStore.vue?vue&type=script&lang=ts&"
export * from "./BothStore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports